<template>
  <v-card class="cart-container" style="height: 100% !important">
    <v-card-text class="pt-1 pl-0 pr-0" style="height: 100% !important">
      <template>
        <v-row class="pl-3 pr-3">
          <v-col cols="2" class="pt-3 pb-3">
            <v-text-field
              ref="order_number"
              :value="last_order_code_solicitud"
              label="N° Orden"
              readonly
              outlined
              hide-details
            ></v-text-field>
          </v-col>

          <v-col
            cols="3"
            class="pt-3 pb-3"
            style="padding-left: 8px; padding-right: 8px;"
          >
            <v-menu
              v-model="menuDateInvoice"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  ref="order_date"
                  :value="date_invoice"
                  label="Fecha"
                  readonly
                  clearable
                  v-on="on"
                  outlined
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker
                :value="date_invoice"
                @input="menuDateInvoice = false"
                no-title
                locale="es"
                @change="set_date_invoice"
              >
              </v-date-picker>
            </v-menu>
          </v-col>

          <v-col
            cols="1"
            style="padding-top:0px; padding-left: 0px; padding-right: 0;"
          >
            <label>Cortesia</label>
            <v-btn-toggle
              v-model="cortesia"
              :value="cortesia"
              mandatory
              dense
              color="green darken-3"
              @change="handleCortesia()"
              class="float-right"
            >
              <v-btn
                value="false"
                class="btn-show-mode"
                style="height:32px; min-width: 10px; font-size: 11px;"
              >
                NO
              </v-btn>
              <v-btn
                value="true"
                class="btn-show-mode"
                style="height:32px; min-width: 10px; font-size: 11px;"
              >
                SI
              </v-btn>
            </v-btn-toggle>
          </v-col>

          <v-col
            cols="2"
            style="padding-top:0px; margin-left: 5px; margin-right: 47px"
          >
            <label>Prioridad</label>
            <v-btn-toggle
              v-model="type_prioridad"
              mandatory
              dense
              color="green darken-3"
              @change="handlePrioridad()"
              class="float-right"
            >
              <v-btn
                value="NORMAL"
                class="btn-show-mode"
                style="height:32px; font-size: 11px;"
              >
                NORMAL
              </v-btn>
              <v-btn
                value="EMERGENCIA"
                class="float-right btn-show-mode btn-emergencia"
                style="height:32px; font-size: 11px;"
              >
                EMERGENCIA
              </v-btn>
            </v-btn-toggle>
          </v-col>
          <v-col cols="3" style="padding-top:0px;">
            <label>Lugar Toma De Muestra</label>
            <v-btn-toggle
              v-model="lugar_atencion"
              mandatory
              dense
              color="green darken-3"
              @change="handlePrioridad()"
              class="float-right"
            >
              <v-btn
                value="OFICINA"
                class="btn-show-mode"
                style="height:32px; font-size: 11px;"
              >
                Oficina
              </v-btn>
              <v-btn
                value="DIRECCION"
                class="float-right btn-show-mode btn-emergencia"
                style="height:32px; font-size: 11px;"
              >
                Domicilio
              </v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>

        <hr class="separator-line" v-if="selected_station && worker == null" />
        <v-row class="pl-3 pr-3" v-if="selected_station && worker == null">
          <v-col cols="11" class="pb-4">
            <v-autocomplete
              :value="worker_id"
              :items="workers"
              label="Trabajador"
              hide-details
              outlined
              :item-text="customTextWorkers"
              item-value="id"
              clearable
              @change="handleSelectWorker"
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-row class="pl-3 pr-3" v-if="worker">
          <v-col cols="12" class="pt-0 pb-0">
            <v-list two-line class="pt-0 pb-0">
              <v-list-item class="pl-1 pr-1">
                <v-list-item-content>
                  <v-list-item-title>
                    <v-icon color="blue" class="mr-2" size="18">
                      fas fa-user-cog
                    </v-icon>
                    <span
                      class="
                        text-uppercase
                        font-weight-bold
                        cart-label-customer
                      "
                      >{{ worker.fullname }}</span
                    >
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <span class="ml-8">{{ worker.payment_type }}</span>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon @click="handleClearWorker" color="red">
                    <v-icon>far fa-times-circle</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>

        <hr class="separator-line" />

        <v-row class="pl-3 pr-3">
          <!--Paciente-->
          <v-col cols="5" class="pb-3" v-if="customer == null">
            <v-autocomplete
              ref="customer_id"
              :items="customers"
              label="Paciente"
              outlined
              :item-text="customTextPaciente"
              item-value="id"
              clearable
              :value="customer_id"
              :loading="isLoading"
              @change="handleSelectCustomer"
              :filter="customFilter"
              v-on:keyup.enter="searchPaciente($event)"
              :rules="[
                () => !!customer_id || 'Es necesario seleccionar un Paciente',
              ]"
              hide-details="auto"
              required
            >
              <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title>{{
                    data.item.surname + " " + data.item.name
                  }}</v-list-item-title>
                  <v-list-item-subtitle v-if="data.item.type_document_id">
                    {{ data.item.type_document.name }}: {{ data.item.document }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>

            <!-- <v-autocomplete
              :items="customers"
              label="Paciente"
              outlined
              :item-text="customTextPaciente"
              item-value="id"
              clearable
              hide-details
              :value="customer_id"
              @change="handleSelectCustomer"
              :filter="customFilter"
            >
              <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title>{{
                    data.item.surname + " " + data.item.name
                  }}</v-list-item-title>
                  <v-list-item-subtitle v-if="data.item.type_document_id">
                    {{ data.item.type_document.name }}: {{ data.item.document }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete> -->
          </v-col>
          <v-col cols="1" class="pl-0" v-if="customer == null">
            <v-icon
              color="success"
              class="mt-2"
              @click="handleViewCreateCustomer"
            >
              fas fa-plus-circle
            </v-icon>
          </v-col>

          <v-col cols="6" class="pt-0 pb-0" v-if="customer">
            <v-list two-line class="pt-0 pb-0">
              <v-list-item class="pl-1 pr-1">
                <v-list-item-content>
                  <v-list-item-title>
                    <v-icon color="green" class="mr-2" size="18">
                      fas fa-user-tag
                    </v-icon>
                    <span
                      class="
                        text-uppercase
                        font-weight-bold
                        cart-label-customer
                      "
                      >{{ customer.surname + " " + customer.name }}</span
                    >
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <span class="ml-8"
                      >{{ customer.type_document.name }}:
                      {{ customer.document }}</span
                    >
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <span class="ml-8"
                      >Fecha Nacimiento: {{ customer.born_date }}</span
                    >
                  </v-list-item-subtitle>

                  <v-list-item-subtitle>
                    <span class="ml-8"
                      >Edad: {{ calcula_edad(customer.born_date) }}</span
                    >
                    <span class="ml-8">Sexo: {{ customer.gender }}</span>
                  </v-list-item-subtitle>
                  <!-- <v-list-item-subtitle>
                    <span class="ml-8">Sexo: {{ customer.gender }}</span>
                  </v-list-item-subtitle> -->
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon @click="handleClearCustomer" color="red">
                    <v-icon>far fa-times-circle</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-col>
          <!--Fin Paciente-->

          <!--Inicio médico-->
          <v-col cols="5" class="pb-3" v-if="doctor == null">
            <v-autocomplete
              ref="doctor_id"
              :items="doctors"
              label="Médico"
              outlined
              :item-text="customText"
              item-value="id"
              clearable
              :value="doctor_id"
              :loading="isLoadingMedico"
              @change="handleSelectDoctor"
              :filter="customFilter"
              v-on:keyup.enter="searchMedico($event)"
              hide-details="auto"
              required
            >
              <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title>{{
                    data.item.fullname
                  }}</v-list-item-title>
                  <v-list-item-subtitle>
                    DNI: {{ data.item.document }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>

            <!-- <v-autocomplete
              :value="doctor_id"
              :items="doctors"
              label="Médico"
              hide-details
              outlined
              :item-text="customText"
              item-value="id"
              clearable
              @change="handleSelectDoctor"
              :filter="customFilter"
            >
              <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title>{{
                    data.item.fullname
                  }}</v-list-item-title>
                  <v-list-item-subtitle>
                    DNI: {{ data.item.document }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete> -->
          </v-col>
          <v-col cols="1" class="pl-0" v-if="doctor == null">
            <v-icon
              color="success"
              class="mt-2"
              @click="handleViewCreateDoctor"
            >
              fas fa-plus-circle
            </v-icon>
          </v-col>

          <v-col cols="6" class="pt-0 pb-0" v-if="doctor">
            <v-list two-line class="pt-0 pb-0">
              <v-list-item class="pl-1 pr-1">
                <v-list-item-content>
                  <v-list-item-title>
                    <v-icon color="green" class="mr-2" size="18">
                      fas fa-user-tag
                    </v-icon>
                    <span
                      class="
                        text-uppercase
                        font-weight-bold
                        cart-label-customer
                      "
                      >{{ doctor.fullname }}</span
                    >
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <span class="ml-8">DNI: {{ doctor.document }}</span>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon @click="handleClearDoctor" color="red">
                    <v-icon>far fa-times-circle</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-col>
          <!--Fin médico-->
        </v-row>

        <hr class="separator-line" />

        <v-row class="pl-3 pr-3">
          <!--Inicio Empresa-->
          <v-col cols="5" class="pb-4" v-if="company == null">
            <v-autocomplete
              ref="company_id"
              :items="companies"
              label="Convenio / Empresas"
              outlined
              item-text="name"
              item-value="id"
              clearable
              :value="company_id"
              :loading="isLoadingCompanie"
              @change="handleSelectCompany"
              :filter="customFilter"
              v-on:keyup.enter="searchCompany($event)"
              hide-details="auto"
              required
            >
              <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title>{{ data.item.name }}</v-list-item-title>
                  <v-list-item-subtitle>
                    RUC: {{ data.item.ruc }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
            <!-- <v-autocomplete
              :value="company_id"
              :items="companies"
              label="Convenio"
              hide-details
              outlined
              :item-text="customText"
              item-value="id"
              clearable
              @change="handleSelectCompany"
              :filter="customFilter"
            >
              <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title>{{ data.item.name }}</v-list-item-title>
                  <v-list-item-subtitle>
                    RUC: {{ data.item.ruc }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete> -->
          </v-col>

          <v-col cols="1" class="pl-0" v-if="company == null">
            <v-icon
              color="success"
              class="mt-2"
              @click="handleViewCreateCompany"
            >
              fas fa-plus-circle
            </v-icon>
          </v-col>

          <v-col cols="6" class="pt-0 pb-0" v-if="company">
            <v-list two-line class="pt-0 pb-0">
              <v-list-item class="pl-1 pr-1">
                <v-list-item-content>
                  <v-list-item-title>
                    <v-icon color="green" class="mr-2" size="18">
                      fas fa-user-tag
                    </v-icon>
                    <span
                      class="
                        text-uppercase
                        font-weight-bold
                        cart-label-customer
                      "
                      >{{ company.name }}</span
                    >
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <span class="ml-8"> RUC: {{ company.ruc }} </span>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon @click="handleClearCompany" color="red">
                    <v-icon>far fa-times-circle</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-col>
          <!--Fin Empresa-->

          <!-- Inicio Oficina -->
          <v-col cols="5">
            <v-autocomplete
              ref="sedes"
              :value="sede_atencion_id"
              v-model="sede_atencion_id"
              :items="offices"
              label="SEDES"
              outlined
              :item-text="customTextOffice"
              item-value="id"
              hide-details="auto"
              required
            ></v-autocomplete>
          </v-col>
          <!-- Fin Oficina -->
        </v-row>

        <hr class="separator-line" />
        <v-row style="height: 41% !important">
          <v-col cols="12" class="pt-1 pb-1">
            <template>
              <div class="section-list-items-cart">
                <v-list
                  dense
                  two-line
                  class="list-cart-items pt-0 pb-0"
                  style="height: 100% !important"
                >
                  <v-list-item
                    v-for="(product, index) in cart"
                    :key="product.id"
                    class="cart-item pl-2 pr-2"
                  >
                    <v-list-item-content
                      class="pt-0 pb-0 cart-item-content"
                      @click="hanldleClickItemCart(product)"
                    >
                      <!--<v-list-item-content class="pt-0 pb-0 cart-item-content">-->
                      <v-list-item-title>
                        <span class="text-uppercase font-weight-bold">
                          {{ product.code }} - {{ product.description }}
                        </span>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        <span class="cart-item-quantity">
                          {{ product.quantity }}
                        </span>
                      </v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-action class="mb-1 cart-item-action">
                      <v-list-item-action-text>
                        <span
                          v-if="product.discount_value"
                          class="font-weight-bold mr-2"
                        >
                          {{
                            getAmountProductDiscount(product) | currency("S/")
                          }}
                        </span>
                        <span v-else class="font-weight-bold mr-2">{{
                          product.price | currency("S/")
                        }}</span>

                        <span
                          @click="handleDeleteItem(product, index)"
                          class="cart-item-delete"
                        >
                          <v-icon size="18" color="red">fas fa-times</v-icon>
                        </span>
                        <!-- <v-icon
                          v-if="product.is_bonus"
                          size="18"
                          class="ml-2"
                          color="green"
                          @click="handleChangeBonus(product)"
                        >
                          fas fa-gift
                        </v-icon>
                        <v-icon
                          v-else
                          size="18"
                          class="ml-2"
                          color="grey lighten-1"
                          @click="handleChangeBonus(product)"
                        >
                          fas fa-gift
                        </v-icon> -->
                      </v-list-item-action-text>
                      <v-list-item-action-text
                        v-if="
                          product.discount_value && product.discount_value > 0
                        "
                      >
                        <span
                          class="label-amount-original label-price-discounted"
                        >
                          {{ product.subtotal | currency("S/") }}
                        </span>
                      </v-list-item-action-text>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </div>
            </template>
          </v-col>
        </v-row>
        <hr class="separator-line" />

        <!-- Agregar input para obervacion -->

        <v-col cols="12">
          <v-textarea
            style="padding-bottom: 0;"
            solo
            name="input-7-4"
            v-model="obervacion"
            rows="4"
            label="Oberservacion"
          ></v-textarea>
        </v-col>

        <v-row justify="center" v-if="selected_station">
          <v-row class="pl-3 pr-3">
            <v-col cols="4" class="pt-0 pl-6">
              <v-btn
                block
                dark
                color="red"
                height="45"
                @click="handleShowListRequest"
              >
                CANCELAR
              </v-btn>
            </v-col>
            <v-col cols="8" class="pt-0 pr-6">
              <v-btn
                block
                dark
                color="green"
                height="45"
                @click="handleShowPayment"
              >
                GUARDAR
              </v-btn>
            </v-col>
          </v-row>
        </v-row>

        <v-row justify="center" v-else>
          <v-col cols="4" class="pt-0">
            <v-btn
              dark
              block
              color="blue"
              height="45"
              @click="handleSaveSale"
              :loading="processing"
            >
              GUARDAR
            </v-btn>
          </v-col>

          <v-col cols="7" class="pt-0" v-if="sale_station">
            <v-btn
              dark
              block
              color="green"
              height="45"
              @click="handleShowPayment"
            >
              GUARDAR
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </v-card-text>

    <Prices ref="Prices"></Prices>

    <create-update ref="CreateUpdate"></create-update>
    <create-update-doctor ref="CreateUpdateDoctor"></create-update-doctor>
    <create-update-company ref="CreateUpdateCompany"></create-update-company>

    <Cortesia
      ref="cortesia"
      :handle-change-cortesia="handleChangeCortesia"
    ></Cortesia>

    <v-snackbar v-model="cant_pay" top color="error">
      {{ message_validation }}
      <v-btn dark text @click="handleCloseMessageValidation"> Cerrar </v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import router from "@/router/index";
import ArrayTools from "../../helpers/ArrayTools";
import Prices from "../../components/sales/Prices";
import CreateUpdate from "../../components/customers/CreateUpdate";
import CreateUpdateDoctor from "../../components/doctors/CreateUpdate";
import CreateUpdateCompany from "../../components/companies/CreateUpdate";
import Cortesia from "./Cortesia";
import { LoadingSpinner } from "../../helpers/Spinner/Loading.spinner";

export default {
  name: "Patient",
  components: {
    Prices,
    CreateUpdate,
    CreateUpdateDoctor,
    CreateUpdateCompany,
    Cortesia,
  },
  data() {
    return {
      menuDateInvoice: false,
      cant_pay: false,
      message_validation: null,
      processing: false,
      type_prioridad: "NORMAL",
      lugar_atencion: "OFICINA",
      obervacion: "",
      sede_atencion_id: null,
      cortesia: "false",
      isLoading: false,
      isLoadingMedico: false,
      isLoadingCompanie: false,
      isLoadingClient: false,
      text_search: null,
    };
  },
  computed: {
    ...mapState("authentication", ["office_id"]),
    ...mapState("customers", ["customers"]),
    ...mapState("doctors", ["doctors"]),
    ...mapState("companies", ["companies"]),
    ...mapState("employees", ["workers"]),
    ...mapState("offices", ["offices"]),
    ...mapState("inventories", ["catalogue"]),
    ...mapState("services", ["services"]),
    ...mapState("sales", [
      "cart",
      "subtotal",
      "igv",
      "total",
      "customer",
      "customer_id",
      "doctor",
      "doctor_id",
      "company",
      "company_id",
      "product",
      "discount",
      "type_operation",
      "date_invoice",
      "sale_station",
      "worker",
      "worker_id",
      "rounding",
      "total_rounded",
      "total_gratuitas",
      "last_order_code",
      "last_order_code_solicitud",
      "document_active",
      "client",
      "client_id",
      "usuario_cortesia_id",
    ]),
    ...mapState("clients", ["clients"]),
    ...mapState("stations", ["selected_station"]),
    ...mapState("cotizaciones", ["select_cotizacion"]),
  },
  methods: {
    handleShowListRequest() {
      //this.router('/app/atencion/solicitud-analisis');
      this.clearData();
      router.push("/app/atencion/solicitud-analisis");
    },
    ...mapMutations("sales", ["set_date_invoice"]),
    ...mapActions("customers", ["getCustomers", "setCustomers"]),
    ...mapActions("doctors", ["getDoctors", "setDoctors"]),
    ...mapActions("companies", ["getCompanies", "setCompanies"]),
    ...mapActions("employees", ["getWorkers"]),
    ...mapActions("offices", ["getOffices"]),
    ...mapActions("cotizaciones", [
      "getCotizacionById",
      "clear_set_select_cotizacion",
    ]),
    ...mapActions("sales", [
      "run_set_cart",
      "replace_product_cart",
      "delete_product_cart",
      "clearAmount",
      "select_customer",
      "select_doctor",
      "select_company",
      "clearData",
      "run_set_sale",
      "setViewPrices",
      "select_product",
      "setTypeOperation",
      "setDateInvoice",
      "selectWorker",
      "storeByStation",
      "updateByStation",
      "getLastOrderCode",
      "select_is_client",
      "select_document_active",
      "calulateAmounts",
      "saveSolicitud",
      "getLastOrderCodeSolicitud",
      "select_client",
      "select_usuario_cortesia",
      "add_product_to_cart",
    ]),
    ...mapActions("clients", ["getClients", "setClients"]),
    customTextOffice(item) {
      let text = item.name;
      return text;
    },
    customTextPaciente(item) {
      let text = item.surname + " " + item.name;
      return text;
    },
    customText(item) {
      let text = item.fullname;

      return text;
    },
    customTextClient(item) {
      let text = item.name;

      return text;
    },
    customTextWorkers(item) {
      let text = item.fullname;

      return text;
    },
    handleSelectCustomer(value) {
      // console.log("valueeee ::>>>>", value);
      if (value == null || value == undefined) {
        this.select_customer(null);
      } else {
        let selected_customer = ArrayTools.getElementById(
          this.customers,
          value
        );
        this.select_customer(selected_customer);
      }
    },
    calcula_edad(fecha_nac) {
      let edad = ArrayTools.calcula_edad(fecha_nac);
      return edad;
    },
    handleSelectDoctor(value) {
      if (value == null || value == undefined) {
        this.select_doctor(null);
      } else {
        let selected_doctor = ArrayTools.getElementById(this.doctors, value);
        this.select_doctor(selected_doctor);
      }
    },
    handlePriceConvenio(cart, company_id) {
      let newCart = [];
      if (cart) {
        cart.forEach((value) => {
          if (value.detail_price.length > 0) {
            const service_price = value.detail_price.find(
              (dtp) => dtp.company_id == company_id
            );
            if (service_price) {
              let item = Object.assign({}, value);
              item.price_aux = item.price;
              item.price = parseFloat(service_price.price);
              newCart.push(item);
            } else {
              value.price_aux = value.price;
              newCart.push(value);
            }
          } else {
            value.price_aux = value.price;
            newCart.push(value);
          }
        });
      }
      this.run_set_cart(newCart);
    },
    handlePriceBase(cart) {
      let newCart = [];
      if (cart) {
        cart.forEach((value) => {
          let item = Object.assign({}, value);
          item.price = value.monto_base;
          newCart.push(item);
          // if (value.monto_convenio > 0) {
          //   let item = Object.assign({}, value);
          //   item.price = value.monto_base;
          //   newCart.push(item);
          // } else {
          //   newCart.push(value);
          // }
        });
      }
      this.run_set_cart(newCart);
    },
    handleSelectCompany(value) {
      if (value == null || value == undefined) {
        this.select_company(null);
        this.calulateAmounts();
      } else {
        let selected_company = ArrayTools.getElementById(this.companies, value);
        this.select_company(selected_company);
        // this.select_client(selected_company);
        this.select_is_client(false);
        this.select_document_active("true");
        // ? agregar el precio convenio automaticamente
        this.handlePriceConvenio(this.cart, value);
        this.calulateAmounts();
      }
    },
    handleSelectClient(value) {
      if (value == null || value == undefined) {
        this.select_client(null);
      } else {
        let selected_client = ArrayTools.getElementById(this.clients, value);
        this.select_client(selected_client);
        this.select_is_client(true);
        this.select_document_active("true");
      }
    },
    handleSelectWorker(value) {
      if (value == null || value == undefined) {
        //this.customer_id = null;
        this.selectWorker(null);
      } else {
        let selected_worker = ArrayTools.getElementById(this.workers, value);
        this.selectWorker(selected_worker);
      }
    },
    handleClearCustomer() {
      //this.customer_id = null
      this.select_customer(null);
    },
    handleClearDoctor() {
      //this.customer_id = null
      this.select_doctor(null);
    },
    handleClearCompany() {
      this.handlePriceBase(this.cart);
      this.calulateAmounts();
      this.select_company(null);
    },
    handleClearWorker() {
      this.selectWorker(null);
    },
    handleDeleteItem(product, index) {
      // console.log(product, index)
      this.delete_product_cart({ product, index });
    },
    handleCloseMessageValidation() {
      this.cant_pay = false;
      this.message_validation = null;
    },
    handleShowPayment() {
      if (this.customer == null) {
        this.cant_pay = true;
        this.message_validation = "Debe seleccionar un paciente.";
      } else if (this.cart.length == 0) {
        /*else if (this.doctor == null) {
                this.cant_pay = true;
                this.message_validation = 'Debe seleccionar un médico.';
            } */
        this.cant_pay = true;
        this.message_validation = "Debe seleccionar al menos un análisis.";
      } else {
        if (this.type_operation === "sale") {
          this.$refs.payment.showForm("Registro de pago de venta", true);
        } else {
          this.$refs.payment.showForm("Registro de pago de pedido", true);
        }
      }
    },
    hanldleClickItemCart(product) {
      this.select_product(product);
      // console.log(product);
      this.setViewPrices(true);
    },
    handleChangeTypeOperation(value) {
      this.setTypeOperation(value);
      this.clearData();
    },
    getAmountProductDiscount(product) {
      let amount = 0;
      let subtotal = Math.round(product.subtotal * 100) / 100;
      let discount = Math.round(product.discount_value * 100) / 100;
      amount = Math.round((subtotal - discount) * 100) / 100;
      // console.log(product);
      return amount;
    },
    handleChangeBonus(product) {
      let productItem = Object.assign({}, product);
      productItem.is_bonus = !productItem.is_bonus;
      this.replace_product_cart(productItem);
    },
    handleViewCreateCustomer() {
      this.$refs.CreateUpdate.showForm("Nuevo Paciente", "create");
    },
    handleViewCreateDoctor() {
      this.$refs.CreateUpdateDoctor.showForm("Nuevo Médico", "create");
    },
    handleViewCreateCompany() {
      this.$refs.CreateUpdateCompany.showForm("Nueva Empresa", "create");
    },
    async handleSaveSale() {
      this.processing = true;
      if (this.customer == null) {
        this.cant_pay = true;
        this.message_validation = "Debe seleccionar un cliente.";
        this.processing = false;
      }
      // if (this.doctor == null) {
      //   this.cant_pay = true;
      //   this.message_validation = "Debe seleccionar un Médico.";
      //   this.processing = false;
      // }

      // else if (this.company == null) {
      //   this.cant_pay = true;
      //   this.message_validation = "Debe seleccionar una empresa";
      //   this.processing = false;
      // }
      if (this.cart.length == 0) {
        this.cant_pay = true;
        this.message_validation = "Debe seleccionar al menos un producto.";
        this.processing = false;
      }
      if (this.processing) {
        await this.handleCalculateCortesia();
        let sale = this.setEntitySale();

        if (this.sale_station == null) {
          await this.saveSolicitud(sale);
          if (this.customer == null) {
            this.type_prioridad = "NORMAL";
            this.lugar_atencion = "OFICINA";
            this.obervacion = "";
            this.sede_atencion_id = null;
            this.cortesia = "false";
          }
        } else {
          await this.updateByStation(sale);
        }
        this.processing = false;
      }
    },
    setEntitySale() {
      let sale = {
        office_id: this.office_id,
        id: this.sale_station,
        date_invoice: this.date_invoice,
        worker_id: this.worker_id,
        customer_id: this.customer_id,
        doctor_id: this.doctor_id,
        company_customer_id: this.company_id,
        client_id: this.client_id,
        type_operation: this.type_operation,
        products: this.cart,
        discount: this.discount,
        subtotal: this.subtotal,
        igv: this.igv,
        total: this.total,
        rounding: this.rounding,
        total_rounded: this.total_rounded,
        total_gratuitas: this.total_gratuitas,
        station_id: this.selected_station ? this.selected_station.id : null,
        observacion: this.obervacion,
        sede_atencion_id: this.sede_atencion_id,
        type_prioridad: this.type_prioridad,
        lugar_atencion: this.lugar_atencion,
        cortesia: this.cortesia,
        usuario_cortesia_id: this.usuario_cortesia_id,
      };
      return sale;
    },
    customFilter(item, queryText, itemText) {
      // console.log(item);
      let textName = "";
      if (item.name) {
        if (item.fullname) {
          textName = item.fullname.toLowerCase();
        } else {
          textName = item.name.toLowerCase();
        }
      }
      let textDocument = "";
      if (item.document) {
        textDocument = item.document.toLowerCase();
      }
      let searchText = queryText.toLowerCase();

      return (
        textName.indexOf(searchText) > -1 ||
        textDocument.indexOf(searchText) > -1
      );
    },
    handlePrioridad() {
      // console.log(this.type_prioridad)
      // if (this.type_prioridad == "true") {
      //   this.select_document_active("FACTURA");
      // } else {
      //   this.select_document_active(this.type_prioridad);
      // }
    },
    handleCortesia() {
      if (this.cortesia == "true") this.$refs.cortesia.showForm();
    },
    async loadFist() {
      // await this.getLastOrderCode();
      await this.getLastOrderCodeSolicitud();
      // console.log(this.last_order_code);
    },
    handleChangeCortesia(usuario) {
      if (usuario) {
        this.select_usuario_cortesia(usuario);
      }
    },
    async handleCalculateCortesia() {
      if (this.usuario_cortesia_id) {
        // ? actualizar el carrito con bonus
        let newCart = [];
        if (this.cart) {
          this.cart.forEach((value) => {
            let item = Object.assign({}, value);
            item.is_bonus = true;
            newCart.push(item);
          });
        }
        this.run_set_cart(newCart);
        this.calulateAmounts();
      } else {
        // ? actualizar el carrito sin bonus
        let newCart = [];
        if (this.cart) {
          this.cart.forEach((value) => {
            let item = Object.assign({}, value);
            item.is_bonus = false;
            newCart.push(item);
          });
        }
        this.run_set_cart(newCart);
        this.calulateAmounts();
      }
    },
    convertServiceAsProduct(service) {
      return {
        barcode: null,
        brand_name: null,
        category: null,
        category_id: null,
        category_name: null,
        description: service.name,
        code: service.code,
        inventory_id: null,
        price: service.base_price,
        product_id: service.id,
        sku: null,
        stock: null,
        type_item: "service",
        detail_price: service.detail_price,
      };
    },
    calculateDiscountValue(product) {
      let discount_value = 0;
      if (product.discount_type) {
        discount_value = parseFloat(product.discount_amount);
        if (product.discount_type == "Porcentaje") {
          let percentage = parseFloat(product.discount_amount);
          let discount = parseFloat(product.subtotal) * (percentage / 100);
          discount_value = Math.round(discount * 100) / 100;
        }
      }
      return discount_value;
    },

    addItemToCart(product) {
      let serviceProduct = this.convertServiceAsProduct(product);
      this.select_product("service product", serviceProduct);
      let item_action = "add";

      //let productFounded = ArrayTools.existProductInCart(this.cart, serviceProduct.product_id, serviceProduct.type_item);
      let productFounded = serviceProduct;

      let productToAdd = Object.assign({}, this.product);

      let id = new Date().getTime();
      //let quantity = parseFloat(this.form.quantity);
      let quantity = 1;
      let discount_type = null;
      let discount_amount = 0;
      let discount_value = 0;

      if (productFounded) {
        item_action = "add";

        productToAdd = Object.assign({}, productFounded);

        id = productToAdd.id;
        //quantity = parseFloat(this.form.quantity);
        quantity = 1;

        discount_type = productToAdd.discount_type;
        discount_amount =
          productToAdd.discount_amount || parseFloat(product.discount_amount);
        discount_value =
          product.discount_amount != null
            ? parseFloat(product.discount_amount)
            : productToAdd.discount_value;
      }

      let cart_item = {
        id: id,
        inventory_id: productToAdd.inventory_id,
        category_id: productToAdd.category_id,
        category_name: productToAdd.category_name,
        product_id: productToAdd.product_id,
        description: productToAdd.description,
        code: productToAdd.code,
        sub_description: null,
        imei: null,
        number: null,
        modality: null,
        plan_id: null,
        plan_name: null,
        operator: null,
        modality_start: null,
        plan_start: null,
        modality_end: null,
        plan_id_end: null,
        plan_name_end: null,
        quantity: quantity,
        price: parseFloat(productToAdd.price),
        discount_type: discount_type,
        discount_amount: discount_amount,
        discount_value: discount_value,
        subtotal: quantity * parseFloat(productToAdd.price),
        commission: 0,
        type_item: productToAdd.type_item,
        is_bonus: false,
        worker_id: null,
        note: null,
        monto_base: parseFloat(productToAdd.price),
        monto_convenio: parseFloat(product.monto_convenio),
        detail_price: serviceProduct.detail_price,
      };

      if (this.company_id) {
        const service_price = serviceProduct.detail_price?.find(
          (dtp) => dtp.company_id == this.company_id
        );
        if (service_price) cart_item.price = parseFloat(service_price.price);
      }

      if (item_action === "add") {
        if (this.company != null) {
          if (cart_item.monto_convenio > 0) {
            cart_item.price = cart_item.monto_convenio;
          }

          this.add_product_to_cart(cart_item);
        } else {
          this.add_product_to_cart(cart_item);
        }
      } else {
        discount_value = this.calculateDiscountValue(cart_item);
        cart_item.discount_value = discount_value;
        this.replace_product_cart(cart_item);
      }
    },

    async searchCotizacion() {
      if (this.select_cotizacion) {
        LoadingSpinner.Circle();
        const cotizacion = await this.getCotizacionById({
          id: this.select_cotizacion,
        });

        if (cotizacion.customer) {
          if (!this.customers.find((dt) => dt.id == cotizacion.customer.id)) {
            this.setCustomers([...this.customers, cotizacion.customer]);
          }
        }
        if (cotizacion.doctor) {
          if (!this.doctors.find((dt) => dt.id == cotizacion.doctor.id)) {
            this.setDoctors([...this.doctors, cotizacion.doctor]);
          }
        }

        if (cotizacion.client) {
          if (!this.clients.find((dt) => dt.id == cotizacion.client.id)) {
            this.setClients([...this.clients, cotizacion.client]);
          }
        }

        // this.client_id_aux = cotizacion.clin_id;
        // if (cotizacion.companyCustomer) {
        //   if (
        //     !this.companies.find((dt) => dt.id == cotizacion.companyCustomer.id)
        //   ) {
        //     this.setCompanies([...this.doctors, cotizacion.companyCustomer]);
        //   }
        // }

        if (cotizacion) {
          if (cotizacion.customer_id) {
            this.handleSelectCustomer(cotizacion.customer_id);
          }
          if (cotizacion.doctor_id) {
            this.handleSelectDoctor(cotizacion.doctor_id);
          }
          if (cotizacion.companies_id) {
            this.handleSelectCompany(cotizacion.companies_id);
          }
          if (cotizacion.clin_id) {
            this.handleSelectClient(cotizacion.clin_id);
          }

          // ? agregar el detalle al car
          // if (cotizacion.detail.length > 0) {
          //   const services = [...this.services];
          //   cotizacion.detail.map((dt) => {
          //     const serviceAux = services.find(
          //       (dti) => dti.id == dt.analisis_id
          //     );
          //     if (serviceAux) this.addItemToCart(serviceAux);
          //   });
          // }

          if (cotizacion.detail.length > 0) {
            cotizacion.detail.map((dt) => {
              const cotizacionService = cotizacion.services.find(
                (dtAux) => dtAux.id == dt.analisis_id
              );

              cotizacionService.discount_amount = dt.discount;
              this.addItemToCart(cotizacionService);

              // const cantAgain = cotizacionDetail.quantity || 1;
              // dt.discount_amount = cotizacionDetail.discount;
              // console.log("--->>>", dt);
              // for (let index = 0; index < cantAgain; index++)
            });
          }
        }
        LoadingSpinner.Remove();
      }
    },
    async searchPaciente(event) {
      this.isLoading = true;
      const value = event.target.value;
      let filters = {};
      if (value.length > 0) {
        if (!isNaN(value)) filters = { ...filters, document: value };
        else filters = { ...filters, fullname: value };

        await this.getCustomers({ ...filters, active: true });
      } else {
        await this.getCustomers();
      }
      this.isLoading = false;
    },
    async searchMedico(event) {
      this.isLoadingMedico = true;
      const value = event.target.value;
      let filters = {};
      if (value.length > 0) {
        if (!isNaN(value)) filters = { ...filters, document: value };
        else filters = { ...filters, fullname: value };
        await this.getDoctors({ ...filters, active: true });
      } else {
        await this.getDoctors({ active: true });
      }
      this.isLoadingMedico = false;
    },
    async searchCompany(event) {
      this.isLoadingCompanie = true;
      const value = event.target.value;
      let filters = {};
      if (value.length > 0) {
        if (!isNaN(value)) filters = { ...filters, document: value };
        else filters = { ...filters, fullname: value };
        await this.getCompanies({ ...filters, active: true });
      } else {
        await this.getCompanies();
      }
      this.isLoadingCompanie = false;
    },
    async searchClient(event) {
      this.isLoadingCompanie = true;
      const value = event.target.value;
      let filters = {};
      if (value.length > 0) {
        if (!isNaN(value)) filters = { ...filters, document: value };
        else filters = { ...filters, fullname: value };
        await this.getClients({ ...filters, active: true });
      } else {
        await this.getClients();
      }
      this.isLoadingCompanie = false;
    },

    handleClearClient() {
      this.select_client(null);
      // this.select_is_client(null);
    },
  },
  created() {
    this.setTypeOperation("sale");
    if (!this.selected_station) {
      this.setDateInvoice(this.$moment().format("YYYY-MM-DD"));
    }
    this.loadFist();

    this.select_client(null);
    this.getOffices();

    // obtener datos de cotizacion
    this.searchCotizacion();
  },
  mounted() {
    this.getCustomers({ active: true });
    this.getDoctors({ active: true });
    this.getCompanies();
    let filters = {
      office_id: this.office_id,
    };
    // this.getWorkers(filters);
    if (!this.selected_station) {
      this.run_set_cart([]);
      this.clearData();
      this.run_set_sale(null);
    }
  },
  destroyed() {
    this.clear_set_select_cotizacion(null);
  },
};
</script>

<style scoped>
.label-discount {
  color: #f44336;
}

.v-text-field__details {
  margin-bottom: 0px !important;
}
.amount-summary {
  min-height: 30px !important;
}

.list-cart-items {
  overflow-y: auto;
}

.label-amount-original {
  display: block !important;
}

.v-list-item__action-text {
  font-size: 0.85rem !important;
}

.label-price-discounted {
  text-decoration: line-through;
  text-decoration-color: #c62828;
}

.section-list-items-cart {
  height: 35vh;
  overflow-y: auto;
}

.cart-item-content {
  cursor: pointer;
}
</style>
